import { useRouter } from "next/router";
import { Dropdown } from "antd";
import Image from "next/image";
// import Icon from "@ant-design/icons/lib/components/Icon";
import { langs, localOptions } from "../utils/common";
// import SwitchLgSvg from "../static/switch-lg.svg";
import styles from "./index.module.scss";
import { track, languageProperties, source, clickEvent } from "@/sdk/sensors";
import useChangeLanguage from "../hooks/use-change-language";
import classNames from "classnames";

export default function SelectComponent(props: any) {
  const router = useRouter();
  const { locale } = router;

  const localeLang = locale ?? "zh"; // 默认语言-中文
  // const [showText, setShowText] = useState(langs[i18n.language].name);
  const { changeLanguage } = useChangeLanguage(); // 切换语言自定义hooks

  // useEffect(() => {
  //   if (i18n.language !== undefined) {
  //     onChangeLanguage({ key: i18n.language });
  //   }
  // }, [i18n.language]);

  /** 切换语言 */
  // const handlerOnChangeLanguage = (value: any): void => {
  //   // console.log(`selected ${value}`, router);
  //   void i18n.changeLanguage(value); // i18n 自定义字段国际化，需要中划线匹配语言包 zh-CN
  //   langContext.changeAntdDayjsLang(value); // 针对antd和日期国际化 需要下划线来匹配对应语言包 zh_CN

  //   // 当用户再次访问网站时，它将使用这个 cookie 中指定的区域设置来重定向到正确的本地化位置，缓存7天
  //   setLocaleCookie(value);
  //   // 切换路由
  //   router.push({ pathname, query }, router.asPath, {
  //     locale: value,
  //     // scroll: false,
  //     // shallow: true,
  //   });
  // };

  // 切换语言
  const onChangeLanguage = (value: any): void => {
    // console.log(`selected ${value.key}`);
    changeLanguage(value.key);
    // setShowText(langs[value.key].name);

    if (typeof props.onChange === "function") {
      props.onChange(value);
    }
  };

  const onClickLanguage = (value: any): void => {
    onChangeLanguage(value);
    // 埋点
    track(clickEvent.switchlanguage_webclick, {
      source,
      language: languageProperties[value.key],
    });
  };

  return (
    <>
      <div className={styles["switch-lg"]}>
        <Dropdown
          trigger={["click"]}
          menu={{ items: localOptions(localeLang), onClick: onClickLanguage }}
          overlayClassName={styles["switch-lg-popup"]}
        >
          <div
            className={classNames(
              styles["switch-lg-content"],
              // "language",
              "menu-content-plat",
              "menu-content",
              "last-menu-content"
            )}
            onClick={e => {
              e.preventDefault();
            }}
          >
            <div className="switch-lg-icon">
              {/* <SwitchLgSvg></SwitchLgSvg> */}
              <Image src="/switch-lg.svg" alt="" width={20} height={20} />
              {/* <Icon className="g-icon" component={SwitchLgSvg} style={{ fontSize: 20 }} /> */}
              {/* <Image src={SwitchLgSvg.src} alt="switch-language" width={20} height={20} /> */}
            </div>
            {langs[localeLang].name}
          </div>
        </Dropdown>
      </div>
    </>
  );
}
